export default {"src":"/_next/static/media/player_not_found.c6efca71.svg","height":75,"width":74,"blurWidth":0,"blurHeight":0};